import api from "./api";

// Capa de servicios API del Builder de formularios web (doc 0417).
// Wrappers de transporte finos — mismo criterio que webLeads.api.js.

export const listWebForms = () => api.get("/web-forms");

// Catálogo real de Agenda de Citas (`ServicesCatalog`) — registrado ANTES de
// "/web-forms/:id" en el backend para que Express no confunda "services" con
// un :id (misma trampa ya vista con "/embed.js" vs "/:hash").
export const listAvailableServices = () => api.get("/web-forms/services");

export const getWebForm = id => api.get(`/web-forms/${id}`);

export const createWebForm = payload => api.post("/web-forms", payload);

export const updateWebForm = (id, payload) => api.put(`/web-forms/${id}`, payload);

// 0417 #14: borra el formulario y sus dominios; las solicitudes recibidas se conservan.
export const deleteWebForm = id => api.delete(`/web-forms/${id}`);

export const listWebFormDomains = id => api.get(`/web-forms/${id}/domains`);

export const addWebFormDomain = (id, domain) =>
  api.post(`/web-forms/${id}/domains`, { domain });

export const removeWebFormDomain = (id, domain) =>
  api.delete(`/web-forms/${id}/domains`, { data: { domain } });
